import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.7324 7.0266a.719.719 0 0 1 .719.719v5.321h2.301a.719.719 0 1 1 0 1.4381h-3.02a.719.719 0 0 1-.719-.7191v-6.04a.719.719 0 0 1 .719-.719",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.249 10.3917a.287.287 0 0 0-.2034.0843l-1.8048 1.8047a.719.719 0 0 1-1.0169-1.0168l1.8045-1.8045a1.727 1.727 0 0 1 1.2206-.5058 1.726 1.726 0 0 1 1.2205.5057l.3896.3896a.2876.2876 0 0 0 .4495-.0548l.2395-.4015a.7191.7191 0 0 1 1.235.7368l-.2403.4027-.001.0018a1.7258 1.7258 0 0 1-2.699.3324l-.3902-.3902a.288.288 0 0 0-.2036-.0844",
        clipRule: "evenodd"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.7257 4.438a.2876.2876 0 0 0-.2876.2877v11.0732a.2876.2876 0 0 0 .2876.2876H8.249a.7191.7191 0 0 1 0 1.4381H4.7257A1.726 1.726 0 0 1 3 15.7989V4.7257A1.7257 1.7257 0 0 1 4.7257 3h7.1332a1.726 1.726 0 0 1 1.2196.505l1.9276 1.9276c.3233.3235.5051.7623.5052 1.2197V8.249a.719.719 0 1 1-1.4381 0V6.6526a.288.288 0 0 0-.084-.203L12.062 4.5222a.288.288 0 0 0-.2031-.0842z",
        clipRule: "evenodd"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.5286 11.3648c-1.7473 0-3.1638 1.4165-3.1638 3.1638s1.4165 3.1638 3.1638 3.1638 3.1638-1.4165 3.1638-3.1638-1.4165-3.1638-3.1638-3.1638m-4.2183 3.1638c0-2.3297 1.8886-4.2183 4.2183-4.2183 2.3298 0 4.2184 1.8886 4.2184 4.2183 0 2.3298-1.8886 4.2184-4.2184 4.2184s-4.2183-1.8886-4.2183-4.2184",
        clipRule: "evenodd"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.7923 16.7923a.527.527 0 0 1 .7457 0l3.1637 3.1637a.527.527 0 0 1 0 .7457.527.527 0 0 1-.7457 0l-3.1637-3.1637a.527.527 0 0 1 0-.7457",
        clipRule: "evenodd"
    }, "4"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.5286 10.4541c-2.2503 0-4.0745 1.8242-4.0745 4.0745s1.8242 4.0746 4.0745 4.0746a4.056 4.056 0 0 0 2.3675-.758l-.2055-.2055a.67.67 0 0 1-.1962-.4508 3.293 3.293 0 0 1-1.9658.6473c-1.8267 0-3.3076-1.4808-3.3076-3.3076s1.4809-3.3076 3.3076-3.3076c1.8268 0 3.3076 1.4809 3.3076 3.3076a3.293 3.293 0 0 1-.6473 1.9658.67.67 0 0 1 .4508.1962l.2055.2055a4.056 4.056 0 0 0 .758-2.3675c0-2.2503-1.8243-4.0745-4.0746-4.0745m3.5226 6.648a4.343 4.343 0 0 0 .8396-2.5735c0-2.4091-1.953-4.3622-4.3622-4.3622s-4.3622 1.9531-4.3622 4.3622c0 2.4092 1.9531 4.3622 4.3622 4.3622a4.343 4.343 0 0 0 2.5735-.8396l2.7523 2.7522a.671.671 0 0 0 .949 0 .671.671 0 0 0 0-.949zm-.383.0238-.2319-.232a.3837.3837 0 0 0-.5424 0 .3837.3837 0 0 0 0 .5424l.232.2319a4.1 4.1 0 0 0 .5423-.5423m-.3381.7466a4.4 4.4 0 0 0 .5424-.5424l2.7276 2.7276a.3837.3837 0 0 1 0 .5424.3837.3837 0 0 1-.5424 0zm-2.8015-6.3638c-1.6679 0-3.0199 1.352-3.0199 3.0199s1.352 3.02 3.0199 3.02 3.02-1.3521 3.02-3.02-1.3521-3.0199-3.02-3.0199",
        clipRule: "evenodd"
    }, "5"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M12.7071 13.6658c0-.2648.2861-.4794.6391-.4794h2.5566c.353 0 .6391.2146.6391.4794s-.2861.4793-.6391.4793h-2.5566c-.353 0-.6391-.2146-.6391-.4793m0 1.9174c0-.2647.2861-.4793.6391-.4793h2.5566c.353 0 .6391.2146.6391.4793s-.2861.4794-.6391.4794h-2.5566c-.353 0-.6391-.2146-.6391-.4794"
    }, "6")
], "InsightSearchPages", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
